// extracted by css-extract-rspack-plugin
export default {"statusAvatarBackground":"InProgressCommentIndicator-module__statusAvatarBackground__yiUfi","statusAvatar":"InProgressCommentIndicator-module__statusAvatar__eRTUu"};